import { Card, CardMedia, IconButton, Typography, Box, } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import GenersItemMenu from './GenersItemMenu';
import { useEffect } from 'react';

export default function GenerGridViewItem({ index, item, modifiedGenersData, handleItemClick, handleMenuOpen, handleMenuClose, hoveredIndex, setHoveredIndex, hoveredItem, setHoveredItem, }) {

  //console.log("item : ", item)

  return (
    <Card
      onMouseEnter={() => {
        //console.log("onMouseEnter")
        setHoveredIndex(index)
        setHoveredItem(item);
      }}
      onMouseLeave={() => {
        //console.log("onMouseLeave")
        //setHoveredIndex(null)
        //setHoveredItem(null)
      }}
      onClick={() => {
        handleItemClick(item, index,)
      }}
      sx={{
        position: "relative",
        borderRadius: 3,
        overflow: "hidden",
        height: 200,
        cursor: "pointer",
        transition: "transform 0.2s ease",
        "&:hover": { transform: "scale(1.02)" },
        //outline: "2px solid",
        //outlineColor: category?.status === "active" ? "green" : category?.status === "deactivated" ? "red" : "transparent",
      }}>

      {/* Status Badge */}
      {item?.status && (
        <Box
          sx={{
            position: "absolute",
            top: 8,
            left: 8,
            bgcolor: item.status === "active" ? "green" : "red",
            color: "white",
            borderRadius: 1,
            px: 1.5,
            py: 0.5,
            fontSize: 12,
            fontWeight: "bold",
            zIndex: 3,
            textTransform: "capitalize",
          }}>
          {item?.status}
        </Box>
      )}

      {/* Menu Button */}
      <GenersItemMenu
        item={hoveredItem}
        index={hoveredIndex}
        handleMenuOpen={handleMenuOpen}
        handleMenuClose={handleMenuClose}
      />

      <CardMedia
        component="img"
        height="200"
        image={item?.image}
        alt={item?.title}
        sx={{
          objectFit: "cover",
          transition: "transform 0.3s ease",
          "&:hover": { transform: "scale(1.05)" }
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          background: "rgba(0,0,0,0.5)",
          color: "#fff",
          p: 2,
        }}
      >
        <Typography variant="h6" fontWeight="bold">
          {item?.title}
        </Typography>
        <Typography variant="body2" fontSize={11}>
          {item?.["sub-title"]}
        </Typography>
      </Box>
    </Card>
  );
}